class CustomVariantPicker extends HTMLElement {
  constructor() {
    // alert("test from CustomVariantPicker");
    super()
    this.optionsRows = this.querySelectorAll(".options-row");
    this.optionButtons = this.querySelectorAll(".option-button");
    this.availableVariants = JSON.parse(document.getElementById("available-variants").textContent);
    this.selectedVariantId = this.getSelectedVariantId.bind(this)();
    this.selectedVariant = this.availableVariants.find(v => v.id.toString() === this.selectedVariantId);

    this.productSkuElement = document.querySelector(".product-sku__value");
    this.productPriceElement = document.querySelector(".product-price .price__current span");
    this.productForm = document.querySelector("product-form");
    
    if(this.optionsRows.length > 1) {
      this.handleUnavailableProducts.bind(this)();
    }
    this.markSelectedVariant.bind(this)();

    this.optionButtons.forEach(optionButton => {
      optionButton.addEventListener("click", this.variantChangeHandler.bind(this));
    })
  }

// return the selected variant id from the url
// if the variant not available or not exist
// the function return the first available variant and replace
// its id in the url
  getSelectedVariantId() {
    let url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const queryObject = {};

    params.forEach((value, key) => {
      queryObject[key] = value;
    });

    if (queryObject["variant"]) {
      const selectedVariant = this.availableVariants.find(v => v.id.toString() === queryObject["variant"]);
      if (selectedVariant) {
        return queryObject["variant"];
      }
    }
    params.set("variant", this.availableVariants[0].id.toString());
    url.search = params.toString();
    window.history.replaceState(null, "", url.toString());
    return this.availableVariants[0].id.toString();
  }

  handleUnavailableProducts(selectedVariant = null) {
    const selectedVariantOptions = selectedVariant ?. options || this.selectedVariant.options;
    this.optionsRows.forEach((row, rowIndex) => {
      const rowButtons = row.querySelectorAll(".option-button");
      rowButtons.forEach(el => {
        const option = el.value;
        const combinationToCheck = [...selectedVariantOptions];
        combinationToCheck[rowIndex] = option;
        let optionsToCheckString = combinationToCheck.join(" / ");
        
        let optionExist = this.availableVariants.find(v => v.title.includes(optionsToCheckString));
        if (!optionExist && rowIndex > 0) {
          el.setAttribute("disabled", "true");
          el.classList.add("unavailable");
        }
      })

    })
  }

  markSelectedVariant(selectedVariant = null) {
    const selectedVariantOptions = selectedVariant ?. options || this.selectedVariant.options;
    
    this.optionsRows.forEach((row, rowIndex) => {
      const rowButtons = row.querySelectorAll(".option-button");
      rowButtons.forEach(el => {
        const option = el.value;
        if (selectedVariantOptions[rowIndex] === option) {
          el.classList.add("selected");
          return;
        }
        el.classList.remove("selected");
      })
    });
  }

  variantChangeOperation(selectedVariant) {
    this.selectedVariantId = selectedVariant.id;
      this.selectedVariant = selectedVariant;

      let url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set("variant", selectedVariant.id.toString());
      url.search = params.toString();
      window.history.replaceState(null, "", url.toString());

      this.querySelectorAll(".unavailable").forEach(el => {
        el.removeAttribute("disabled");
        el.classList.remove("unavailable");
      })
      if(this.optionsRows.length > 1) {
        this.handleUnavailableProducts(selectedVariant);
      }      
      this.markSelectedVariant(selectedVariant);
      this.productSkuElement.innerHTML = selectedVariant.sku;
      
      
      const currentQuantity = parseInt(this.productForm.querySelector(".qty-input__input").value);
      const selectedVariantPrice = ((selectedVariant.price) / 100);
      
      this.productPriceElement.innerHTML = `$${(selectedVariantPrice * currentQuantity).toFixed(2)}`;

      const variantChangedEvent = new CustomEvent("onVariantChange", {detail: {quantity: currentQuantity}});
      document.dispatchEvent(variantChangedEvent);
  }

  variantChangeHandler(event) {
    const buttonParentRow = event.target.parentElement;
    const buttonIndex = Array.from(buttonParentRow.children).indexOf(event.target);
    const rowIndex = Array.from(buttonParentRow.parentElement.parentElement.children).indexOf(buttonParentRow.parentElement);
    
    const selectedOptionValue = event.target.value;

    const previewsSelectedOptions = this.selectedVariant.options;
    const newSelectedOptions = [...previewsSelectedOptions];
    newSelectedOptions[rowIndex] = selectedOptionValue;
    const newSelectedOptionString = newSelectedOptions.join(" / ");
    const selectedVariant = this.availableVariants.find(v => v.title.includes(newSelectedOptionString));
    
    
    if (selectedVariant) {
      this.variantChangeOperation(selectedVariant);
    } else {
      const selectedOptionFitVariant =   this.availableVariants.find(v => v.title.includes(selectedOptionValue));
      
      if(selectedOptionFitVariant) {
        this.variantChangeOperation(selectedOptionFitVariant);
      }
    }
  }

}



customElements.define("custom-variant-picker", CustomVariantPicker);